import { TEAM_PRODUCT_CATEGORIES_RECEIVED } from '../../actions/product-management/GetTeamProduct';
import { CATEGORIES_RECEIVED } from '../../actions/product-management/GetProductMeta';

const initialState = {
  all: [],
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_PRODUCT_CATEGORIES_RECEIVED: // Deliberate fall through of case
    case CATEGORIES_RECEIVED:
      return Object.assign({}, state, {
        all: action.all,
      });
  }

  return state;
};

export default categories;
